// Module
var code = "<vui-page>\n    <vui-page-title>\n        Choose another mechanic\n    </vui-page-title>\n\n    <vui-page-content>\n        <vui-reassigning-booking></vui-reassigning-booking>\n    </vui-page-content>\n</vui-page>";
// Exports
module.exports = code;